(function () {
  var REFERENCE_HANDLE = 'dinosaurs';
  var REFERENCE_VARIANT_ID = 43771530182723; // Dino Trail, 30x30cm / No Frame / Square
  var REFERENCE_USD_PRICE = 48.00;

  function formatAmount(amount, currencyCode) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
        maximumFractionDigits: (amount % 1 === 0) ? 0 : 2
      }).format(amount) + ' (approx.)';
    } catch (e) {
      return '$' + amount.toFixed(2) + ' ' + currencyCode + ' (approx.)';
    }
  }

  function getCurrencyCode() {
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return window.Shopify.currency.active;
      }
    } catch (e) {}
    return null;
  }

  function updateText(rate, currencyCode) {
    var converted = Math.round(10 * rate);
    var formatted = formatAmount(converted, currencyCode);

    document.querySelectorAll('.dam-usd-amount[data-usd="10"]').forEach(function (el) {
      el.textContent = formatted;
    });

    document.querySelectorAll('.announcement-bar__message span').forEach(function (span) {
      var text = span.textContent;
      if (/\$10\s*USD/i.test(text)) {
        span.textContent = text.replace(/\$10\s*USD/i, formatted);
      }
    });
  }

  function init() {
    var currencyCode = getCurrencyCode();
    if (!currencyCode || currencyCode === 'USD') {
      return;
    }

    fetch('/products/' + REFERENCE_HANDLE + '.js')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (product) {
        if (!product || !product.variants) return;
        var variant = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].id === REFERENCE_VARIANT_ID) {
            variant = product.variants[i];
            break;
          }
        }
        if (!variant) return;
        var localPrice = variant.price / 100;
        var rate = localPrice / REFERENCE_USD_PRICE;
        if (!rate || !isFinite(rate) || rate <= 0) return;
        updateText(rate, currencyCode);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
